
<template>
  <div class="container">
      <div class="body">
          <!-- <div class="viewTop"></div> -->
          <video ref="video" class="video" autoplay></video>
          <canvas ref="canvas" width="480" height="320" style="display: none;"></canvas>
        <div class="ifr_box">
             <!-- <div class="viewTop1"></div> -->
            <img ref='mb_img' class="mb_img" src="../../assets/images/face.png" alt="">
        </div>
      </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import util from "../../utils/util";
export default {
  name: "shotPhoto",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      lists: "",
      showPage: false,
      streamPicture: ""
    };
  },

  mounted: function() {
			this.initCamera();
  },
  methods: {
        initCamera(){
                let self = this;
                var video =self.$refs.video;
                console.log(window.System.global.frames.screen);
                var w = window.System.global.frames.screen.width
                //self.$refs.video.offsetWidth;
                var h =   window.System.global.frames.screen.height;
                //document.documentElement.clientHeight
                //self.$refs.video.offsetHeight;
                //video.style.height=h +'px';

                console.log('w ====  ' + w  +"   &h ===== " +h);
                util.showToast('w ====  ' + w  +"   &h ===== " +h ,10000)
                var constraints = {
                        // audio: true,
                        video: {
                            facingMode: "user",
                            width: w,
                            height: h/2
                            //  width: { min: w, ideal: w, max: w },
                            //  height: { min: h, ideal: h, max: h }
                        }
                 };
                 console.log(navigator.mediaDevices);
                 if(navigator.mediaDevices.getUserMedia){
                    console.log("in mediaDevices.getUserMedia")  ;
                    navigator.mediaDevices.getUserMedia(constraints).then(function(stream){

                    //     if ("srcObject" in video) {
                    //         video.srcObject = stream;
                    //     } else {
                    //      // 防止在新的浏览器里使用它，应为它已经不再支持了
                    //      //兼容webkit内核浏览器
                    //         var CompatibleURL = window.URL || window.webkitURL;
                    //         //将视频流设置为video元素的源
                    //         video.src = CompatibleURL.createObjectURL(stream);
                     //     }
                        // console.log(stream);
                        video.srcObject = stream;
                        self.streamPicture = stream; //关闭摄像头需要用
                        // video.style.width =w+'px'
                        // video.style.height=h +'px'
                        // var mb_img =self.$refs.video;
                        // mb_img.style.width =w+'px'
                        // mb_img.style.height=h +'px'
						video.onloadedmetadata = function(e) {
                            video.play();

						};
					}).catch(function(err) {
                        console.log("访问用户媒体设备失败: " + err.name);
                        util.showToast("访问用户媒体设备失败: " + err,10000)
					});


                    //     return;
                 }else{
                      util.showToast("不支持访问用户媒体")
                 }
                // }
               	// navigator.getUserMedia  = navigator.getUserMedia ||navigator.webkitGetUserMedia ||navigator.mozGetUserMedia;
				// if (navigator.getUserMedia) {
				// 	//调用用户媒体设备, 访问摄像头
                //     navigator.getUserMedia(constraints,function(stream) {
				// 			var video =self.$refs.video;
				// 			video.srcObject = stream;
				// 			self.streamPicture = stream; //关闭摄像头需要用
				// 			video.onloadedmetadata = function(e) {
				// 				video.play();
				// 			};
				// 		}, function(err) {
				// 			console.log("访问用户媒体设备失败: " + err.name);
				// 		})
				// } else {
				// 	//self.$message.error('不支持访问用户媒体');
				// }
		},
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    width:100%;
    height:100%;
    background:rgba(255,255,255,1);
}
.body{
    width:100%;
    height:100%;
    margin-left: 0px;
    flex-direction: column;
    background:rgba(255,255,255,1);
    position: relative;
    display: flex;
    .ifr_box{
        width:100%;
        height:100%;
        position: absolute;
        top:0%;left:0;
        z-index:20;
        img{
            display: block;
            width:100%;
            height:90%;
        }
    }
}
.viewTop{
    display: flex;
    // background-color: red;
    background:rgba(0,0,0,0.3);
    width:100%;
    height:15% ;
}
.viewTop1{
    display: flex;
    // background-color: red;
    width:100%;
    height:15% ;
}

.video{
    background-color: black;
    display: flex;
    width:100%;
    height:50% !important;
    // zoom:0.5,
    transform: scale(1,2);
    transform-origin: 0 0
}
</style>